// Pricing configuration for Local Business Heroes
// Maps currencies to Stripe price IDs and amounts

export const PRICING_CONFIG = {
  GBP: {
    TRIAL_FEE: {
      priceId: 'price_1SGILKB7yIgJMZ5iG0wpFcxY',
      amount: 5,
      currency: 'GBP'
    },
    STARTER: {
      priceId: 'price_1SGILLB7yIgJMZ5ialuFnMHU',
      productId: 'prod_TChk7jCaXUvv09',
      amount: 297,
      currency: 'GBP',
      name: 'Hero Starter',
      credits: 25,
      userLimit: 10,
      features: [
        '£25 complimentary credits/month',
        'Up to 10 users',
        'Up to 1,000 contacts',
        'Unlimited landing pages',
        'Lead capture pages',
        'Hero CRM & Smart Inbox',
        'AI Auto-Responder',
        'Review automation',
        'Calendar booking',
        'Mobile app access',
        'Email support'
      ],
      outcomes: ['2x more leads', '50% time saved', 'Better follow-up'],
      description: 'Perfect for getting started with automation'
    },
    GROWTH: {
      priceId: 'price_1SGILLB7yIgJMZ5iUXbWEey2',
      productId: 'prod_TChkyMHFIDQyxZ',
      amount: 497,
      currency: 'GBP',
      name: 'Hero Growth',
      popular: true,
      credits: 50,
      userLimit: 25,
      features: [
        '£50 complimentary credits/month',
        'Up to 25 users',
        'Everything in Starter',
        'Up to 10,000 contacts',
        'Sales pipelines',
        'AI booking assistant',
        'Multi-channel campaigns',
        'Social media scheduler',
        'ROI dashboard',
        'Missed call text-back',
        'Phone + email support',
        'Setup assistance'
      ],
      outcomes: ['5x more leads', '70% time saved', 'Automated growth'],
      description: 'Most popular - Everything you need to scale'
    },
    DOMINATION: {
      priceId: 'price_1SGILMB7yIgJMZ5i4e0Y8B5T',
      productId: 'prod_TChkmbrrs6sYWA',
      amount: 997,
      currency: 'GBP',
      name: 'Hero Domination',
      credits: 100,
      userLimit: 50,
      features: [
        '£100 complimentary credits/month',
        'Up to 50 users',
        'Everything in Growth',
        'Unlimited contacts',
        'DFY funnel setup',
        'Dedicated success manager',
        'Monthly strategy calls',
        'AI sales assistant',
        'Priority support',
        'Custom integrations'
      ],
      outcomes: ['10x growth potential', 'Complete automation', 'Market leadership'],
      description: 'For serious growth and market domination'
    }
  },
  USD: {
    TRIAL_FEE: {
      priceId: 'price_1SGILKB7yIgJMZ5iaL0mSsPa',
      amount: 5,
      currency: 'USD'
    },
    STARTER: {
      priceId: 'price_1SGILLB7yIgJMZ5ixwFDzywY',
      amount: 297,
      currency: 'USD',
      name: 'Hero Starter',
      credits: 25,
      userLimit: 10,
      features: [
        '$25 complimentary credits/month',
        'Up to 10 users',
        'Up to 1,000 contacts',
        'Unlimited landing pages',
        'Lead capture pages',
        'Hero CRM & Smart Inbox',
        'AI Auto-Responder',
        'Review automation',
        'Calendar booking',
        'Mobile app access',
        'Email support'
      ],
      outcomes: ['2x more leads', '50% time saved', 'Better follow-up'],
      description: 'Perfect for getting started with automation'
    },
    GROWTH: {
      priceId: 'price_1SGILMB7yIgJMZ5i5w0Akr1W',
      amount: 497,
      currency: 'USD',
      name: 'Hero Growth',
      popular: true,
      credits: 50,
      userLimit: 25,
      features: [
        '$50 complimentary credits/month',
        'Up to 25 users',
        'Everything in Starter',
        'Up to 10,000 contacts',
        'Sales pipelines',
        'AI booking assistant',
        'Multi-channel campaigns',
        'Social media scheduler',
        'ROI dashboard',
        'Missed call text-back',
        'Phone + email support',
        'Setup assistance'
      ],
      outcomes: ['5x more leads', '70% time saved', 'Automated growth'],
      description: 'Most popular - Everything you need to scale'
    },
    DOMINATION: {
      priceId: 'price_1SGILMB7yIgJMZ5iLEPNjv6T',
      amount: 997,
      currency: 'USD',
      name: 'Hero Domination',
      credits: 100,
      userLimit: 50,
      features: [
        '$100 complimentary credits/month',
        'Up to 50 users',
        'Everything in Growth',
        'Unlimited contacts',
        'DFY funnel setup',
        'Dedicated success manager',
        'Monthly strategy calls',
        'AI sales assistant',
        'Priority support',
        'Custom integrations'
      ],
      outcomes: ['10x growth potential', 'Complete automation', 'Market leadership'],
      description: 'For serious growth and market domination'
    }
  },
  EUR: {
    TRIAL_FEE: {
      priceId: 'price_EUR_TRIAL_REPLACE_ME',
      amount: 5,
      currency: 'EUR'
    },
    STARTER: {
      priceId: 'price_EUR_STARTER_REPLACE_ME',
      amount: 297,
      currency: 'EUR',
      name: 'Hero Starter',
      credits: 25,
      userLimit: 10,
      features: [
        '€25 complimentary credits/month',
        'Up to 10 users',
        'Up to 1,000 contacts',
        'Unlimited landing pages',
        'Lead capture pages',
        'Hero CRM & Smart Inbox',
        'AI Auto-Responder',
        'Review automation',
        'Calendar booking',
        'Mobile app access',
        'Email support'
      ],
      outcomes: ['2x more leads', '50% time saved', 'Better follow-up'],
      description: 'Perfect for getting started with automation'
    },
    GROWTH: {
      priceId: 'price_EUR_GROWTH_REPLACE_ME',
      amount: 497,
      currency: 'EUR',
      name: 'Hero Growth',
      popular: true,
      credits: 50,
      userLimit: 25,
      features: [
        '€50 complimentary credits/month',
        'Up to 25 users',
        'Everything in Starter',
        'Up to 10,000 contacts',
        'Sales pipelines',
        'AI booking assistant',
        'Multi-channel campaigns',
        'Social media scheduler',
        'ROI dashboard',
        'Missed call text-back',
        'Phone + email support',
        'Setup assistance'
      ],
      outcomes: ['5x more leads', '70% time saved', 'Automated growth'],
      description: 'Most popular - Everything you need to scale'
    },
    DOMINATION: {
      priceId: 'price_EUR_DOMINATION_REPLACE_ME',
      amount: 997,
      currency: 'EUR',
      name: 'Hero Domination',
      credits: 100,
      userLimit: 50,
      features: [
        '€100 complimentary credits/month',
        'Up to 50 users',
        'Everything in Growth',
        'Unlimited contacts',
        'DFY funnel setup',
        'Dedicated success manager',
        'Monthly strategy calls',
        'AI sales assistant',
        'Priority support',
        'Custom integrations'
      ],
      outcomes: ['10x growth potential', 'Complete automation', 'Market leadership'],
      description: 'For serious growth and market domination'
    }
  }
};

// Helper functions
export const getPlanByKey = (currency, planKey) => {
  return PRICING_CONFIG[currency][planKey];
};

export const getTrialFee = (currency) => {
  return PRICING_CONFIG[currency].TRIAL_FEE;
};

export const getAllPlans = (currency) => {
  const config = PRICING_CONFIG[currency];
  return [config.STARTER, config.GROWTH, config.DOMINATION];
};